(ns minorodata.connections.sources.bing-ads
  (:require [minorodata.app.utils :as app.utils]
            [clojure.string :as c.string]
            [cljs.spec.alpha :as spec]
            [spec-tools.core :as st]
            [mold-forms.core :as form-component]))


(spec/def ::name
  (spec/and (st/spec string? {:reason "Please provide a name for the source"})
            (st/spec (complement c.string/blank?) {:reason "Name can't be empty"})))


(spec/def ::description
  (spec/nilable string?))


(spec/def ::auth-credentials-id
  (spec/and (st/spec string? {:reason "Please provide a valid auth token"})
            (st/spec (complement c.string/blank?) {:reason "Please provide a valid auth token"})))


(spec/def ::auth-credentials
  (spec/keys :req-un [::auth-credentials-id]))


(spec/def ::bing-form
  (spec/keys :req-un [::name ::auth-credentials]
             :opt-un [::description]))


;; https://docs.microsoft.com/en-us/azure/active-directory/develop/v2-permissions-and-consent
(def oauth-scope
  (c.string/join " " ["https://ads.microsoft.com/msads.manage" "offline_access"]))


(def oauth-tenant "common")


;; https://docs.microsoft.com/en-us/advertising/guides/authentication-oauth-consent?view=bingads-13
(def oauth-request-uri
  (str "https://login.microsoftonline.com/" oauth-tenant "/oauth2/v2.0/authorize"))


;; https://learn.microsoft.com/en-us/advertising/reporting-service/adgroupperformancereportcolumn?view=bingads-13
(def ad-group-performance-report-columns
  ["AccountName" "AccountNumber" "AccountId" "TimePeriod" "Status"
   "CampaignName" "CampaignId" "AdGroupName" "AdGroupId" "CurrencyCode"
   "AdDistribution" "Impressions" "Clicks" "Ctr" "AverageCpc" "Spend"
   "AveragePosition" "Conversions" "ConversionRate" "CostPerConversion"
   "DeviceType" "Language" "DeviceOS" "ImpressionSharePercent"
   "ImpressionLostToBudgetPercent" "ImpressionLostToRankAggPercent"
   "QualityScore" "ExpectedCtr" "AdRelevance" "LandingPageExperience"
   "HistoricalQualityScore" "HistoricalExpectedCtr" "HistoricalAdRelevance"
   "HistoricalLandingPageExperience" "PhoneImpressions" "PhoneCalls" "Ptr"
   "Network" "TopVsOther" "BidMatchType" "DeliveredMatchType" "Assists" "Revenue"
   "ReturnOnAdSpend" "CostPerAssist" "RevenuePerConversion" "RevenuePerAssist"
   "TrackingTemplate" "CustomParameters" "AccountStatus" "CampaignStatus"
   "AdGroupLabels" "ExactMatchImpressionSharePercent" "CustomerId" "CustomerName"
   "ClickSharePercent" "AbsoluteTopImpressionSharePercent" "FinalUrlSuffix"
   "CampaignType" "TopImpressionShareLostToRankPercent" "TopImpressionShareLostToBudgetPercent"
   "AbsoluteTopImpressionShareLostToRankPercent" "AbsoluteTopImpressionShareLostToBudgetPercent"
   "TopImpressionSharePercent" "AbsoluteTopImpressionRatePercent" "TopImpressionRatePercent"
   "BaseCampaignId" "AllConversions" "AllRevenue" "AllConversionRate" "AllCostPerConversion"
   "AllReturnOnAdSpend" "AllRevenuePerConversion" "ViewThroughConversions" "Goal" "GoalType"
   "AudienceImpressionSharePercent" "AudienceImpressionLostToRankPercent"
   "AudienceImpressionLostToBudgetPercent" "RelativeCtr" "AdGroupType" "AverageCpm"
   "ConversionsQualified" "AllConversionsQualified" "ViewThroughConversionsQualified"
   "ViewThroughRevenue" "VideoViews" "ViewThroughRate" "AverageCPV" "VideoViewsAt25Percent"
   "VideoViewsAt50Percent" "VideoViewsAt75Percent" "CompletedVideoViews" "VideoCompletionRate"
   "TotalWatchTimeInMS" "AverageWatchTimePerVideoView" "AverageWatchTimePerImpression" "Sales"
   "CostPerSale" "RevenuePerSale" "Installs" "CostPerInstall" "RevenuePerInstall" "GoalId"])


(def default-ad-group-performance-report-columns
  ["CampaignName"
   "Impressions"

   ;; This should be required, as it is what we're using for incremental
   "TimePeriod"

   "AdGroupName"
   "Clicks"
   "AverageCpc"
   "Spend"
   "AveragePosition"
   "QualityScore"
   "AccountName"
   "ConversionRate"
   "AdDistribution"
   "Conversions"
   "Ctr"])


(def ad-performance-report-columns
  ["AccountName" "AccountNumber" "AccountId" "TimePeriod" "CampaignName"
   "CampaignId" "AdGroupName" "AdId" "AdGroupId" "AdTitle" "AdDescription"
   "AdDescription2" "AdType" "CurrencyCode" "AdDistribution" "Impressions"
   "Clicks" "Ctr" "AverageCpc" "Spend" "AveragePosition" "Conversions"
   "ConversionRate" "CostPerConversion" "DestinationUrl" "DeviceType" "Language"
   "DisplayUrl" "AdStatus" "Network" "TopVsOther" "BidMatchType" "DeliveredMatchType"
   "DeviceOS" "Assists" "Revenue" "ReturnOnAdSpend" "CostPerAssist"
   "RevenuePerConversion" "RevenuePerAssist" "TrackingTemplate" "CustomParameters"
   "FinalUrl" "FinalMobileUrl" "FinalAppUrl" "AccountStatus" "CampaignStatus"
   "AdGroupStatus" "TitlePart1" "TitlePart2" "TitlePart3" "Headline" "LongHeadline"
   "BusinessName" "Path1" "Path2" "AdLabels" "CustomerId" "CustomerName"
   "CampaignType" "BaseCampaignId" "AllConversions" "AllRevenue" "AllConversionRate"
   "AllCostPerConversion" "AllReturnOnAdSpend" "AllRevenuePerConversion"
   "FinalUrlSuffix" "ViewThroughConversions" "Goal" "GoalType"
   "AbsoluteTopImpressionRatePercent" "TopImpressionRatePercent" "AverageCpm"
   "ConversionsQualified" "AllConversionsQualified" "ViewThroughConversionsQualified"
   "ViewThroughRevenue" "VideoViews" "ViewThroughRate" "AverageCPV" "VideoViewsAt25Percent"
   "VideoViewsAt50Percent" "VideoViewsAt75Percent" "CompletedVideoViews"
   "VideoCompletionRate" "TotalWatchTimeInMS" "AverageWatchTimePerVideoView"
   "AverageWatchTimePerImpression" "AdStrength" "AdStrengthActionItems" "GoalId"])


(def default-ad-performance-report-columns
  ["CampaignName"
   "Impressions"

   ;; This should be required, as it is what we're using for incremental
   "TimePeriod"

   "Clicks"
   "AverageCpc"
   "Spend"
   "AveragePosition"
   "AccountName"
   "ConversionRate"
   "AdDistribution"
   "Conversions"
   "Ctr"])


(def campaign-performance-report-columns
  ["AccountName" "AccountNumber" "AccountId" "TimePeriod" "CampaignStatus"
   "CampaignName" "CampaignId" "CurrencyCode" "AdDistribution" "Impressions"
   "Clicks" "Ctr" "AverageCpc" "Spend" "AveragePosition" "Conversions" "ConversionRate"
   "CostPerConversion" "LowQualityClicks" "LowQualityClicksPercent" "LowQualityImpressions"
   "LowQualityImpressionsPercent" "LowQualityConversions" "LowQualityConversionRate"
   "DeviceType" "DeviceOS" "ImpressionSharePercent" "ImpressionLostToBudgetPercent"
   "ImpressionLostToRankAggPercent" "QualityScore" "ExpectedCtr" "AdRelevance"
   "LandingPageExperience" "HistoricalQualityScore" "HistoricalExpectedCtr"
   "HistoricalAdRelevance" "HistoricalLandingPageExperience" "PhoneImpressions"
   "PhoneCalls" "Ptr" "Network" "TopVsOther" "BidMatchType" "DeliveredMatchType" "Assists"
   "Revenue" "ReturnOnAdSpend" "CostPerAssist" "RevenuePerConversion" "RevenuePerAssist"
   "TrackingTemplate" "CustomParameters" "AccountStatus" "BudgetName" "BudgetStatus"
   "BudgetAssociationStatus" "LowQualityGeneralClicks" "LowQualitySophisticatedClicks"
   "CampaignLabels" "ExactMatchImpressionSharePercent" "CustomerId" "CustomerName"
   "ClickSharePercent" "AbsoluteTopImpressionSharePercent" "FinalUrlSuffix" "CampaignType"
   "TopImpressionShareLostToRankPercent" "TopImpressionShareLostToBudgetPercent"
   "AbsoluteTopImpressionShareLostToRankPercent" "AbsoluteTopImpressionShareLostToBudgetPercent"
   "TopImpressionSharePercent" "AbsoluteTopImpressionRatePercent" "TopImpressionRatePercent"
   "BaseCampaignId" "AllConversions" "AllRevenue" "AllConversionRate" "AllCostPerConversion"
   "AllReturnOnAdSpend" "AllRevenuePerConversion" "ViewThroughConversions" "Goal" "GoalType"
   "AudienceImpressionSharePercent" "AudienceImpressionLostToRankPercent"
   "AudienceImpressionLostToBudgetPercent" "RelativeCtr" "AverageCpm" "ConversionsQualified"
   "LowQualityConversionsQualified" "AllConversionsQualified" "ViewThroughConversionsQualified"
   "ViewThroughRevenue" "VideoViews" "ViewThroughRate" "AverageCPV" "VideoViewsAt25Percent"
   "VideoViewsAt50Percent" "VideoViewsAt75Percent" "CompletedVideoViews" "VideoCompletionRate"
   "TotalWatchTimeInMS" "AverageWatchTimePerVideoView" "AverageWatchTimePerImpression" "Sales"
   "CostPerSale" "RevenuePerSale" "Installs" "CostPerInstall" "RevenuePerInstall" "Downloads"
   "PostClickDownloadRate" "CostPerDownload" "AppInstalls" "PostClickInstallRate" "CPI"
   "Purchases" "PostInstallPurchaseRate" "CPP" "Subscriptions" "PostInstallSubscriptionRate" "CPS"])


(def default-campaign-performance-report-columns
  ["CampaignName"
   "Impressions"

   ;; This should be required, as it is what we're using for incremental
   "TimePeriod"

   "Clicks"
   "AverageCpc"
   "Spend"
   "AveragePosition"
   "QualityScore"
   "AccountName"
   "ConversionRate"
   "AdDistribution"
   "Conversions"
   "Ctr"])


(def keyword-performance-report-columns
  ["AccountName" "AccountNumber" "AccountId" "TimePeriod" "CampaignName" "CampaignId"
   "AdGroupName" "AdGroupId" "Keyword" "KeywordId" "AdId" "AdType" "DestinationUrl"
   "CurrentMaxCpc" "CurrencyCode" "DeliveredMatchType" "AdDistribution" "Impressions"
   "Clicks" "Ctr" "AverageCpc" "Spend" "AveragePosition" "Conversions" "ConversionRate"
   "CostPerConversion" "BidMatchType" "DeviceType" "QualityScore" "ExpectedCtr"
   "AdRelevance" "LandingPageExperience" "Language" "HistoricalQualityScore"
   "HistoricalExpectedCtr" "HistoricalAdRelevance" "HistoricalLandingPageExperience"
   "QualityImpact" "CampaignStatus" "AccountStatus" "AdGroupStatus" "KeywordStatus"
   "Network" "TopVsOther" "DeviceOS" "Assists" "Revenue" "ReturnOnAdSpend" "CostPerAssist"
   "RevenuePerConversion" "RevenuePerAssist" "TrackingTemplate" "CustomParameters"
   "FinalUrl" "FinalMobileUrl" "FinalAppUrl" "BidStrategyType" "KeywordLabels"
   "Mainline1Bid" "MainlineBid" "FirstPageBid" "FinalUrlSuffix" "BaseCampaignId"
   "AllConversions" "AllRevenue" "AllConversionRate" "AllCostPerConversion"
   "AllReturnOnAdSpend" "AllRevenuePerConversion" "ViewThroughConversions" "Goal"
   "GoalType" "AbsoluteTopImpressionRatePercent" "TopImpressionRatePercent" "AverageCpm"
   "ConversionsQualified" "AllConversionsQualified" "ViewThroughConversionsQualified"
   "ViewThroughRevenue" "GoalId"])


(def default-keyword-performance-report-columns
  ["CampaignName"
   "Impressions"

   ;; This should be required, as it is what we're using for incremental
   "TimePeriod"

   "Clicks"
   "AverageCpc"
   "Spend"
   "AveragePosition"
   "QualityScore"
   "AccountName"
   "ConversionRate"
   "AdDistribution"
   "Conversions"
   "Ctr"])


(def conversion-performance-report-columns
  ["AccountName" "AccountNumber" "AccountId" "TimePeriod" "CampaignName"
   "CampaignId" "AdGroupName" "AdGroupId" "Keyword" "KeywordId" "Impressions"
   "Clicks" "Ctr" "Assists" "Conversions" "ConversionRate" "Spend" "Revenue"
   "ReturnOnAdSpend" "CostPerConversion" "CostPerAssist" "RevenuePerConversion"
   "RevenuePerAssist" "DeviceType" "AccountStatus" "CampaignStatus" "AdGroupStatus"
   "KeywordStatus" "AllConversions" "AllRevenue" "AllConversionRate"
   "AllCostPerConversion" "AllReturnOnAdSpend" "AllRevenuePerConversion"
   "ViewThroughConversions" "Goal" "GoalType" "ConversionsQualified" "AllConversionsQualified"
   "ViewThroughConversionsQualified" "ViewThroughRevenue" "GoalId"])


(def default-conversion-performance-report-columns
  ["CampaignName"
   "Impressions"

   ;; This should be required, as it is what we're using for incremental
   "TimePeriod"

   "Clicks"
   "Spend"
   "AccountName"
   "ConversionRate"
   "Conversions"
   "Ctr"])


(def geographic-performance-report-columns
  ["AccountName" "AccountNumber" "AccountId" "TimePeriod" "CampaignName" "CampaignId"
   "AdGroupName" "AdGroupId" "Country" "State" "MetroArea" "City" "CurrencyCode"
   "AdDistribution" "Impressions" "Clicks" "Ctr" "AverageCpc" "Spend" "AveragePosition"
   "ProximityTargetLocation" "Radius" "Language" "BidMatchType" "DeliveredMatchType"
   "Network" "TopVsOther" "DeviceType" "DeviceOS" "Assists" "Conversions" "ConversionRate"
   "Revenue" "ReturnOnAdSpend" "CostPerConversion" "CostPerAssist" "RevenuePerConversion"
   "RevenuePerAssist" "LocationType" "MostSpecificLocation" "AccountStatus" "CampaignStatus"
   "AdGroupStatus" "County" "PostalCode" "LocationId" "BaseCampaignId" "AllConversions"
   "AllRevenue" "AllConversionRate" "AllCostPerConversion" "AllReturnOnAdSpend"
   "AllRevenuePerConversion" "ViewThroughConversions" "Goal" "GoalType"
   "AbsoluteTopImpressionRatePercent" "TopImpressionRatePercent" "AverageCpm"
   "ConversionsQualified" "AllConversionsQualified" "ViewThroughConversionsQualified"
   "Neighborhood" "ViewThroughRevenue" "CampaignType" "AssetGroupId" "AssetGroupName"
   "AssetGroupStatus"])


(def default-geographic-performance-report-columns
  ["CampaignName"
   "Impressions"

   ;; This should be required, as it is what we're using for incremental
   "TimePeriod"

   "Clicks"
   "AverageCpc"
   "Spend"
   "AveragePosition"
   "AccountName"
   "ConversionRate"
   "AdDistribution"
   "Conversions"
   "Ctr"])


(def adgroupcriterions-criterion-type
  ["Age" "CombinedList" "CompanyName"
   "CustomAudience" "CustomerList" "DayTime" "Device" "Gender" "Genre"
   "ImpressionBasedRemarketingList" "Industry" "InMarketAudience"
   "JobFunction" "Location" "LocationIntent" "Placement" "ProductAudience"
   "ProductPartition" "Radius"
   "RemarketingList" "SimilarRemarketingList" "Webpage"])


(def campaigncriterions-criterion-type
  ["Age" "Audience" "CombinedList" "CompanyName" "CustomAudience" "CustomerList"
   "DayTime" "Device" "Gender" "ImpressionBasedRemarketingList" "Industry"
   "InMarketAudience" "JobFunction" "Location" "LocationIntent" "ProductAudience"
   "ProductScope" "Radius" "RemarketingList" "SimilarRemarketingList" "Store" "Webpage"])


;; https://docs.microsoft.com/en-us/advertising/reporting-service/reporttimeperiod?view=bingads-13
(def report-time-periods
  ["Today"
   "Yesterday"
   "LastSevenDays"
   "ThisWeek"
   "LastWeek"
   "Last14Days"
   "Last30Days"
   "LastFourWeeks"
   "ThisMonth"
   "LastMonth"
   "LastThreeMonths"
   "LastSixMonths"
   "ThisYear"
   "LastYear"
   "ThisWeekStartingMonday"
   "LastWeekStartingMonday"
   "LastFourWeeksStartingMonday"])


;; https://docs.microsoft.com/en-us/advertising/guides/reports?view=bingads-13#reptimezones
(def report-time-zones
  ["AbuDhabiMuscat"
   "Adelaide"
   "Alaska"
   "Almaty_Novosibirsk"
   "AmsterdamBerlinBernRomeStockholmVienna"
   "Arizona"
   "AstanaDhaka"
   "AthensIslandanbulMinsk"
   "AtlanticTimeCanada"
   "AucklandWellington"
   "Azores"
   "Baghdad"
   "BakuTbilisiYerevan"
   "BangkokHanoiJakarta"
   "BeijingChongqingHongKongUrumqi"
   "BelgradeBratislavaBudapestLjubljanaPrague"
   "BogotaLimaQuito"
   "Brasilia"
   "Brisbane"
   "BrusselsCopenhagenMadridParis"
   "Bucharest"
   "BuenosAiresGeorgetown"
   "Cairo"
   "CanberraMelbourneSydney"
   "CapeVerdeIsland"
   "CaracasLaPaz"
   "CasablancaMonrovia"
   "CentralAmerica"
   "CentralTimeUSCanada"
   "ChennaiKolkataMumbaiNewDelhi"
   "ChihuahuaLaPazMazatlan"
   "Darwin"
   "EasternTimeUSCanada"
   "Ekaterinburg"
   "FijiKamchatkaMarshallIsland"
   "Greenland"
   "GreenwichMeanTimeDublinEdinburghLisbonLondon"
   "GuadalajaraMexicoCityMonterrey"
   "GuamPortMoresby"
   "HararePretoria"
   "Hawaii"
   "HelsinkiKyivRigaSofiaTallinnVilnius"
   "Hobart"
   "IndianaEast"
   "InternationalDateLineWest"
   "IrkutskUlaanBataar"
   "IslandamabadKarachiTashkent"
   "Jerusalem"
   "Kabul"
   "Kathmandu"
   "Krasnoyarsk"
   "KualaLumpurSingapore"
   "KuwaitRiyadh"
   "MagadanSolomonIslandNewCaledonia"
   "MidAtlantic"
   "MidwayIslandand_Samoa"
   "MoscowStPetersburgVolgograd"
   "MountainTime_US_Canada"
   "Nairobi"
   "Newfoundland"
   "Nukualofa"
   "OsakaSapporoTokyo"
   "PacificTimeUSCanadaTijuana"
   "Perth"
   "Rangoon"
   "Santiago"
   "SarajevoSkopjeWarsawZagreb"
   "Saskatchewan"
   "Seoul"
   "SriJayawardenepura"
   "Taipei"
   "Tehran"
   "Vladivostok"
   "WestCentralAfrica"
   "Yakutsk"])

(def source
  {:id           "bing-ads"
   :enabled      true
   :name         "Bing Ads"
   :description  "Bing Ads"
   :image-source "bing-ads.png"
   :tags         ["marketing"]

   :preview-formatter
   (fn [source]
     (if (:is-token-valid source)
       (str "Authenticated by token")
       [:span {:class "text-kleene-error-01"
               :title "TOKEN EXPIRED"}
        "AUTH TOKEN EXPIRED"]))

   :form
   {:format-for-api
    (fn format-for-api
      [{:keys [auth-credentials name description developer-token]}]
      {:source-type     "bing-ads"
       :name            name
       :description     description
       :source          {:auth-credentials-id (:auth-credentials-id auth-credentials)
                         :is-token-valid      (:is-token-valid auth-credentials)
                         :has-third-leg       true
                         :developer-token     developer-token}})

    :format-for-inputs
    (fn format-for-inputs
      [{:keys [source name description]}]
      (let [{:keys [auth-credentials-id is-token-valid developer-token]}
            source]
        {:name                name
         :description         description
         :developer-token     developer-token
         :auth-credentials    (when (and (some? auth-credentials-id)
                                         (some? is-token-valid))
                                {:auth-credentials-id auth-credentials-id
                                 :is-token-valid      is-token-valid})
         :auth-credentials-id auth-credentials-id
         :is-token-valid      is-token-valid}))

    :validate
    (partial form-component/validate-form ::bing-form)

    :id
    :bing-oauth-form

    :blocks
    [{:block-type :input
      :label      "Source name"
      :required   true
      :name       :name
      :value      ""}

     {:block-type :input
      :label      "Description"
      :name       :description
      :value      ""}

     {:block-type :input
      :label      "Developer token"
      :name       :developer-token
      :value      ""}

     {:block-type :oauth
      :label      "Bing Ads login"
      :name       :auth-credentials
      :required   true

      :request-uri oauth-request-uri

      :params-processor
      (fn [{:keys [client-id redirect-uri state scope response-type]}]
        {:response_type response-type
         :scope         scope
         :client_id     client-id
         :redirect_uri  redirect-uri
         :state         state})

      :response-processor
      (fn [data _]
        (select-keys data [:auth-credentials-id :is-token-valid]))

      :oauth-connector-type "bing-ads"
      :has-third-leg        true
      :response-type        "code"
      :client-id            "0f6545af-0411-42a6-83f4-8c6715c21381"
      :scope                oauth-scope}

     {:block-type :submit
      :content    "save"}]}

   :extract-form
   {:format-for-api
    (fn format-for-api
      [{:keys [name description status
               action destination-table report
               columns
               ad-performance-columns
               campaign-performance-columns
               keyword-performance-columns
               conversion-performance-columns
               geographic-performance-columns
               aggregation
               custom-date-range from-date to-date
               report-time-period report-time-zone]}]
      {:name          name
       :description   description
       :status        status
       :output-tables [destination-table]

       :config
       {:extracts
        [{:action                         action
          :report                         report
          :destination-table              destination-table
          :columns                        columns
          :ad-performance-columns         ad-performance-columns
          :campaign-performance-columns   campaign-performance-columns
          :keyword-performance-columns    keyword-performance-columns
          :conversion-performance-columns conversion-performance-columns
          :geographic-performance-columns geographic-performance-columns
          :aggregation                    aggregation
          :custom-date-range              custom-date-range
          :from-date                      from-date
          :to-date                        to-date
          :report-time-period             report-time-period
          :report-time-zone               report-time-zone}]}})

    :format-for-inputs
    (fn format-for-inputs
      [{:extract/keys [name description status config source-id]}]
      (let [extract (get-in config [:extracts 0])]
        (merge
         (select-keys extract [:report :action :destination-table
                               :columns
                               :ad-performance-columns
                               :campaign-performance-columns
                               :keyword-performance-columns
                               :conversion-performance-columns
                               :geographic-performance-columns
                               :aggregation
                               :custom-date-range  :from-date :to-date
                               :report-time-period :report-time-zone])
         (app.utils/keep-non-nil-keys
          {:name          name
           :description   description
           :status        status
           :output-tables []
           :source-id     source-id}))))

    :validate
    (constantly nil)

    :id
    :bing-ads-extract-form

    :blocks
    [{:block-type :input
      :label      "Extract name"
      :required   true
      :name       :name
      :value      ""}

     {:block-type :input
      :label      "Description"
      :name       :description
      :value      ""}

     {:block-type :select
      :label      "Status"
      :name       :status
      :options    [{:name "active" :value "active"}
                   {:name "paused" :value "paused"}]
      :required   true
      :value      "active"}

     {:block-type :subtitle
      :content    "Extract configuration"}

     {:block-type :form-value
      :name       :source-id}

     {:block-type :select
      :label      "report"
      :name       :report
      :options    [{:name "Ad group performance"   :value "ad-group-performance"}
                   {:name "Ad performance"         :value "ad-performance"}
                   {:name "Campaign performance"   :value "campaign-performance"}
                   {:name "Keyword performance"    :value "keyword-performance"}
                   {:name "Conversion performance" :value "conversion-performance"}
                   {:name "Geographic performance" :value "geographic-performance"}
                   {:name "Campaigns"              :value "campaigns"}
                   {:name "Ad Groups"              :value "adgroups"}
                   {:name "Ads"                    :value "ads"}
                   {:name "Ad Group Criterions"    :value "adgroupcriterions"}
                   {:name "Conversion Goals"       :value "conversiongoals"}
                   {:name "Campaign Criterions"    :value "campaigncriterions"}

                   {:name "---- Coming soon ----"  :value "comingsoon"}
                   {:name "Audiences"              :value "audiences"}
                   {:name "Keywords"               :value "keywords"}]
      :disabled   false
      :required   true
      :value      "ad-group-performance"}

     {:block-type :checkbox
      :label      "Custom date range"
      :name       :custom-date-range
      :type       :checkbox
      :value      false
      :conditions [[:eq [:report :value] "ad-group-performance"]
                   [:eq [:report :value] "ad-performance"]
                   [:eq [:report :value] "campaign-performance"]
                   [:eq [:report :value] "keyword-performance"]
                   [:eq [:report :value] "conversion-performance"]
                   [:eq [:report :value] "geographic-performance"]]}

     {:block-type :select
      :label      "Report time period"
      :name       :report-time-period
      :options    (mapv (fn [tp] {:name tp :value tp}) report-time-periods)
      :required   false
      :conditions [[:and [[:custom-date-range :value] [:report :value]] [false "ad-group-performance"]]
                   [:and [[:custom-date-range :value] [:report :value]] [false "ad-performance"]]
                   [:and [[:custom-date-range :value] [:report :value]] [false "campaign-performance"]]
                   [:and [[:custom-date-range :value] [:report :value]] [false "keyword-performance"]]
                   [:and [[:custom-date-range :value] [:report :value]] [false "conversion-performance"]]
                   [:and [[:custom-date-range :value] [:report :value]] [false "geographic-performance"]]]}

     {:block-type :date-picker
      :label      "From date"
      :name       :from-date
      :required   false
      :conditions [[:eq [:custom-date-range :value] true]]}

     {:block-type :date-picker
      :label      "To date"
      :name       :to-date
      :required   false
      :conditions [[:eq [:custom-date-range :value] true]]}

     {:block-type :select
      :name       :report-time-zone
      :label      "Report time zone"
      :value      "GreenwichMeanTimeDublinEdinburghLisbonLondon"
      :required   true
      :options    (map (fn [tz] {:name tz :value tz}) report-time-zones)
      :conditions [[:eq [:report :value] "ad-group-performance"]
                   [:eq [:report :value] "ad-performance"]
                   [:eq [:report :value] "campaign-performance"]
                   [:eq [:report :value] "keyword-performance"]
                   [:eq [:report :value] "conversion-performance"]
                   [:eq [:report :value] "geographic-performance"]]}

     ;; https://docs.microsoft.com/en-us/advertising/reporting-service/reportaggregation?view=bingads-13
     {:block-type :select
      :name       :aggregation
      :label      "Aggregation"
      :value      "Daily"
      :options    [{:name "Hourly", :value "Hourly"}
                   {:name "Daily", :value "Daily"}
                   {:name "Weekly", :value "Weekly"}
                   {:name "Monthly", :value "Monthly"}
                   {:name "Yearly", :value "Yearly"}
                   {:name "HourOfDay", :value "HourOfDay"}
                   {:name "DayOfWeek", :value "DayOfWeek"}
                   {:name "WeeklyStartingMonday", :value "WeeklyStartingMonday"}
                   {:name "Summary", :value "Summary"}]
      :conditions [[:eq [:report :value] "ad-group-performance"]
                   [:eq [:report :value] "ad-performance"]
                   [:eq [:report :value] "campaign-performance"]
                   [:eq [:report :value] "keyword-performance"]
                   [:eq [:report :value] "conversion-performance"]
                   [:eq [:report :value] "geographic-performance"]]}


     {:block-type :multiselect
      :label      "Columns"
      :name       :columns
      :options    ad-group-performance-report-columns
      :value      default-ad-group-performance-report-columns
      :conditions [[:eq [:report :value] "ad-group-performance"]]}

     {:block-type :multiselect
      :label      "Columns"
      :name       :ad-performance-columns
      :options    ad-performance-report-columns
      :value      default-ad-performance-report-columns
      :conditions [[:eq [:report :value] "ad-performance"]]}

     {:block-type :multiselect
      :label      "Columns"
      :name       :campaign-performance-columns
      :options    campaign-performance-report-columns
      :value      default-campaign-performance-report-columns
      :conditions [[:eq [:report :value] "campaign-performance"]]}

     {:block-type :multiselect
      :label      "Columns"
      :name       :keyword-performance-columns
      :options    keyword-performance-report-columns
      :value      default-keyword-performance-report-columns
      :conditions [[:eq [:report :value] "keyword-performance"]]}

     {:block-type :multiselect
      :label      "Columns"
      :name       :conversion-performance-columns
      :options    conversion-performance-report-columns
      :value      default-conversion-performance-report-columns
      :conditions [[:eq [:report :value] "conversion-performance"]]}

     {:block-type :multiselect
      :label      "Columns"
      :name       :geographic-performance-columns
      :options    geographic-performance-report-columns
      :value      default-geographic-performance-report-columns
      :conditions [[:eq [:report :value] "geographic-performance"]]}

     {:block-type :multiselect
      :label      "Criterion Type"
      :name       :adgroupcriterions-criterion-type
      :options    adgroupcriterions-criterion-type
      :value      adgroupcriterions-criterion-type
      :conditions [[:eq [:report :value] "adgroupcriterions"]]}

     {:block-type :multiselect
      :label      "Criterion Type"
      :name       :campaigncriterions-criterion-type
      :options    campaigncriterions-criterion-type
      :value      campaigncriterions-criterion-type
      :conditions [[:eq [:report :value] "campaigncriterions"]]}


     {:block-type :subtitle
      :content    "Data loading options"}

     {:block-type :select
      :label      "Load method"
      :name       :action
      :options    [{:name "Drop, Create, Load" :value "replace"}
                   {:name "Truncate, Load"     :value "reload"}
                   {:name "Append"             :value "append"}]
      :required   true
      :value      "replace"}

     {:content "Drop table, Create table, load entire table (selected columns)"
      :conditions [[:eq [:action :value] "replace"]]}

     {:content "Truncate table, Load entire table (selected columns)"
      :conditions [[:eq [:action :value] "reload"]]}

     {:content "Load entire table (selected columns) into the destination table no table recreation, no truncation"
      :conditions [[:eq [:action :value] "append"]]}

     {:block-type :subtitle
      :content    "Destination table"}

     {:block-type  :warehouse-destination
      :name        :destination-table}

     {:block-type :submit
      :content    "save"}]}})
